module.exports = __webpack_public_path__ + "img/vuetify.624068b2.png";